import { useQuery } from "@tanstack/react-query";
import { api } from "../../api";
import { useEvalStewardEnabled } from "./useEvalStewardEnabled";

export interface FeedbackTraceParams {
  workspaceId: string;
  threadId: string;
  assistantMessageIndex: number;
}

export function useFeedbackTrace({
  workspaceId,
  threadId,
  assistantMessageIndex,
}: FeedbackTraceParams) {
  const { isEvalStewardEnabled } = useEvalStewardEnabled();

  return useQuery({
    queryKey: [
      "evalSteward",
      "feedbackTrace",
      workspaceId,
      threadId,
      assistantMessageIndex,
    ],
    queryFn: () =>
      api.getFeedbackTrace(workspaceId, threadId, assistantMessageIndex),
    enabled:
      isEvalStewardEnabled &&
      Boolean(workspaceId && threadId && Number.isFinite(assistantMessageIndex)),
  });
}
